import { CancelText } from 'owa-locstrings/lib/strings/canceltext.locstring.json';
import { NextText } from './FilePickerPaneBottomPart.locstring.json';
import loc from 'owa-localize';
import * as React from 'react';
import FilePickerAction from '../store/schema/FilePickerAction';

import { PrimaryButton, DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { observer } from 'mobx-react-lite';

const styles = require('./FilePickerPaneBottomPart.scss');

export interface FilePickerPaneBottomPartProps {
    supportedActions: FilePickerAction[];
    onNextClicked: () => void;
    onCancelClicked: () => void;
}

const FilePickerPaneBottomPart = observer(function FilePickerPaneBottomPart(
    props: FilePickerPaneBottomPartProps
) {
    const disableNextButton = !props.supportedActions || props.supportedActions.length == 0;
    return (
        <div className={styles.container}>
            <div className={styles.buttonContainer}>
                <PrimaryButton
                    className={styles.button}
                    disabled={disableNextButton}
                    ariaLabel={loc(NextText)}
                    onClick={props.onNextClicked}>
                    {loc(NextText)}
                </PrimaryButton>

                <span className={styles.cancelButtonContainer}>
                    <DefaultButton
                        className={styles.button}
                        ariaLabel={loc(CancelText)}
                        onClick={props.onCancelClicked}>
                        {loc(CancelText)}
                    </DefaultButton>
                </span>
            </div>
        </div>
    );
});
export default FilePickerPaneBottomPart;
